import React, { useEffect, useRef, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

// Caminho do som
const NOTIFY_SOUND = "https://app.captacrm.com.br/notify.mp3";

// Cores por status
const COLOR_MAP = {
  azul: "#2986f6",
  vermelho: "#de3535",
  amarela: "#eab308"
};

export default function WhatsappIconWithBadge({
  showBadge,
  badgeCount,
  badgeColor = "vermelho"
}) {
  // Guarda o valor anterior do badge (para saber se aumentou)
  const prevCountRef = useRef(0);

  // Detecta se já houve interação do usuário (para liberar som)
  const [userInteracted, setUserInteracted] = useState(false);

  useEffect(() => {
    const handler = () => setUserInteracted(true);
    window.addEventListener("click", handler, { once: true });
    window.addEventListener("keydown", handler, { once: true });
    return () => {
      window.removeEventListener("click", handler);
      window.removeEventListener("keydown", handler);
    };
  }, []);

  // Extrai status e count (permite número ou objeto)
  const count =
    typeof badgeCount === "object" ? badgeCount.count : badgeCount;
  const status =
    typeof badgeCount === "object" ? badgeCount.status : badgeColor;

  // Cor do badge
  const color = COLOR_MAP[status] || COLOR_MAP.vermelho;
  // Cor do pulso animado
  const pulseColor =
    status === "azul"
      ? "#2986f680"
      : status === "amarela"
      ? "#eab30880"
      : "#de353580";

  // Som de notificação só se badge azul aumentou, badge visível e usuário já interagiu
  useEffect(() => {
    if (
      showBadge &&
      status === "azul" &&
      count > 0 &&
      count > prevCountRef.current &&
      userInteracted
    ) {
      const audio = new window.Audio(NOTIFY_SOUND);
      audio.volume = 0.3;
      // Não precisa await, só dispara
      audio.play().catch(() => {});
    }
    prevCountRef.current = count;
  }, [count, status, showBadge, userInteracted]);

  // Badge animado com shadow pulsante
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <FaWhatsapp size={28} color="#25d366" />
      {showBadge && count > 0 && (
        <>
          <span
            style={{
              position: "absolute",
              top: -6,
              right: -6,
              background: color,
              color: "#fff",
              borderRadius: "50%",
              fontSize: 12,
              padding: "2px 7px",
              minWidth: 16,
              textAlign: "center",
              fontWeight: 700,
              boxShadow: `0 0 6px ${color}a6`,
              animation: "pulse-badge-captacrm 1.2s infinite",
              zIndex: 2
            }}
          >
            {count}
          </span>
          {/* Style isolado para evitar conflitos */}
          <style>
            {`
            @keyframes pulse-badge-captacrm {
              0% { box-shadow: 0 0 0 0 ${pulseColor}; }
              70% { box-shadow: 0 0 0 12px ${pulseColor.replace("80", "00")}; }
              100% { box-shadow: 0 0 0 0 ${pulseColor.replace("80", "00")}; }
            }
            `}
          </style>
        </>
      )}
    </div>
  );
}